import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Button } from 'react-bootstrap'
// import ScrollspyNav from "react-scrollspy-nav";
import { ThemeConsumer } from '../../context/ThemeContext';

function Header() {

  useEffect(() => {
    let el = document.querySelector('#darkTheme');
    if (el) {
      el.addEventListener('click', function () {
          document.body.classList.toggle('dark');
      });
    }
  }, [])

  return (
    <>
      <div className="header">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="navigation">
                <Navbar bg="light" expand="lg">
                  <Link className="navbar-brand" to={'/'}><img src='img/logo.png' alt="" /></Link>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse>
                    {/* <ScrollspyNav
                      scrollTargetIds={["home", "price", "portfolio", "testimonial", "app", "blog",]}
                      offset={100}
                      activeNavClass="active"
                      scrollDuration="1000"
                      headerBackground="true"
                    > */}
                    <Nav
                      className="ml-auto"
                      onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
                    >
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/">About</Nav.Link></Nav.Item>
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/">How it works</Nav.Link></Nav.Item>
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/">Support </Nav.Link></Nav.Item>
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/api">API</Nav.Link></Nav.Item>
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/swap">Swap</Nav.Link></Nav.Item>
                      <Nav.Item><Nav.Link className="nav-Nav.link" as={Link} to="/dashboard">Exchange</Nav.Link></Nav.Item>
                    </Nav>
                    {/* </ScrollspyNav> */}

                  </Navbar.Collapse>

                  <div className="signin-btn">
                    <ThemeConsumer>
                      {({ data, update }) => (
                        <Button variant="default" onClick={update} id="darkTheme">
                          {data.theme === 'light' ? (
                          <i className="icon ion-md-moon"></i>
                          ) : (
                          <i className="icon ion-md-sunny"></i>
                          )}
                        </Button>
                      )}
                    </ThemeConsumer>
                    <Link to={'./dashboard'}>Dashboard</Link>
                    <Link className="btn btn-primary ml-3" to={'/login'}>Sign in</Link>
                  </div>
                </Navbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header;